import type { IColumn } from 'types'

import { routes } from 'helpers/routes'
import { Breadcrumb } from 'recoils/atoms'

export const HEADERS: IColumn[] = [
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 6,
    textAlign: 'left',
  },
  {
    key: 'code',
    label: 'company:header.code.label',
    sortable: true,
    width: 10,
    textAlign: 'left',
  },
  {
    key: 'name',
    label: 'company:header.name.label',
    sortable: true,
    width: 28,
    textAlign: 'left',
  },
  {
    key: 'phones',
    label: 'company:header.phone.label',
    sortable: false,
    width: 10,
    textAlign: 'left',
  },
  {
    key: 'address',
    label: 'common:header.address.label',
    sortable: false,
    width: 40,
    textAlign: 'left',
  },
  {
    key: 'isActive',
    label: 'common:header.status.label',
    sortable: true,
    width: 6,
    textAlign: 'left',
  },
]

export const SKELETON_INFO = [
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '56px',
    widthDescription: '228px',
  },
  {
    widthTitle: '56px',
    widthDescription: '228px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
]

export const SKELETON_ADDRESS = [
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '56px',
    widthDescription: '170px',
  },
  {
    widthTitle: '56px',
    widthDescription: '170px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
]

export const HEADERS_LOADING: IColumn[] = [
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 16,
  },
  {
    key: 'name',
    label: 'branch:header.name.label',
    sortable: true,
    width: 28,
  },
  {
    key: 'phone',
    label: 'branch:header.contactNumber.label',
    sortable: false,
    width: 10,
  },
  {
    key: 'address',
    label: 'common:header.address.label',
    sortable: false,
    width: 46,
  },
]

export const BREADCRUMBS_LIST: Breadcrumb[] = [
  {
    key: routes.company.path,
    label: 'layout:companyManagement.breadcrumb',
  },
]

export const BREADCRUMBS_CREATE: Breadcrumb[] = [
  {
    key: routes.company.path,
    label: 'layout:companyManagement.breadcrumb',
  },
  {
    key: routes.company.create.path,
    label: 'layout:createCompany.breadcrumb',
  },
]

export const renderBreadcrumbsEdit = (id: string): Breadcrumb[] => [
  {
    key: routes.company.path,
    label: 'layout:companyManagement.breadcrumb',
  },
  {
    key: `${routes.company.path}/${id}/detail`,
    label: 'layout:detailCompany.breadcrumb',
  },
  {
    key: `${routes.company.path}/${id}/edit`,
    label: 'layout:editCompany.breadcrumb',
  },
]

export const renderBreadcrumbsDetail = (id: string): Breadcrumb[] => [
  {
    key: routes.company.path,
    label: 'layout:companyManagement.breadcrumb',
  },
  {
    key: `${routes.company.path}/${id}/detail`,
    label: 'layout:detailCompany.breadcrumb',
  },
]

export const COMPANYTEMPLATE = 'companyImportTemplate'
